import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  DialogTitle
} from '@mui/material';
import { Close, Save, Euro, MonitorWeight } from '@mui/icons-material';
import AdminAPI from '../service/AdminAPI';

class SetCustomPriceWeightPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      cachedOrder: null,
      order: null
    }
  }

  handleClose = () => {
    this.setState({ show: false });
    this.props.onClose();
  }

  handleSubmit = (ev) => {
    var _order = this.state.cachedOrder;

    AdminAPI.SetPriceWeightForCustomerOrder(_order.orderID, _order.CustomPrice, _order.CustomWeight)
      .then((_res) => {
        window.location.reload();
      })
      .catch(console.error);

    this.props.onClose();
    ev.preventDefault();
  }

  componentDidUpdate() {
    if (this.state.show !== this.props.show) {
      this.setState({ show: this.props.show, order: this.props.order, cachedOrder: Object.assign({}, this.props.order) });
    }
  }

  handlePriceChange = (ev) => {
    this.state.cachedOrder.CustomPrice = parseFloat(ev.target.value);
    this.setState({ cachedOrder: this.state.cachedOrder });
  }

  handleWeightChange = (ev) => {
    this.state.cachedOrder.CustomWeight = parseFloat(ev.target.value);
    this.setState({ cachedOrder: this.state.cachedOrder });
  }

  resetEntry = () => {
    this.state.cachedOrder.CustomPrice = this.state.order.CustomPrice;
    this.state.cachedOrder.CustomWeight = this.state.order.CustomWeight;
    this.setState({ cachedOrder: this.state.cachedOrder });
  }

  render() {
    return (
      this.state.cachedOrder ?
        (
          <Dialog
            open={this.state.show}
            onHide={this.handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: { xs: '12px', sm: '20px' },
                overflow: 'hidden',
                margin: { xs: '16px', sm: '32px' },
                maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
              }
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={this.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                zIndex: 1,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
              }}
            >
              <Close />
            </IconButton>

            {/* Header with gradient */}
            <Box
              sx={{
                background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                pt: { xs: 3, sm: 4 },
                pb: { xs: 2.5, sm: 3 },
                px: { xs: 2, sm: 3 },
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1.5, sm: 2 }
              }}
            >
              <Save sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
              <DialogTitle sx={{ p: 0, flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                  Preis für Einzelprodukt bearbeiten
                </Typography>
              </DialogTitle>
            </Box>

            <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
              <Box component="form" onSubmit={this.handleSubmit} id="price-weight-form">
                <TextField
                  fullWidth
                  label="Produktname"
                  name={this.state.order.Name}
                  value={this.state.cachedOrder.Name}
                  disabled
                  sx={{ mb: 3 }}
                />

                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 3 }}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Preis (€)"
                    name="Price"
                    value={this.state.cachedOrder.CustomPrice}
                    onChange={this.handlePriceChange}
                    InputProps={{
                      startAdornment: <Euro sx={{ mr: 1, color: '#2e7d32' }} />
                    }}
                    inputProps={{ step: 0.01, min: 0 }}
                  />

                  <TextField
                    fullWidth
                    type="number"
                    label="Gewicht (Kg)"
                    name="Weight"
                    value={this.state.cachedOrder.CustomWeight}
                    onChange={this.handleWeightChange}
                    InputProps={{
                      startAdornment: <MonitorWeight sx={{ mr: 1, color: '#2e7d32' }} />
                    }}
                    inputProps={{ step: 0.01, min: 0 }}
                  />
                </Box>

                <Button
                  fullWidth
                  variant="outlined"
                  onClick={this.resetEntry}
                  sx={{
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 600,
                    borderColor: '#ddd',
                    color: '#666',
                    '&:hover': {
                      borderColor: '#bbb',
                      bgcolor: '#f5f5f5'
                    }
                  }}
                >
                  Zurücksetzen
                </Button>
              </Box>
            </DialogContent>

            <Divider />

            <DialogActions sx={{ 
              p: { xs: 2, sm: 3 }, 
              gap: { xs: 1.5, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              <Button
                onClick={this.handleClose}
                variant="outlined"
                size="large"
                fullWidth
                sx={{
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#ddd',
                  color: '#666',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  order: { xs: 2, sm: 1 },
                  '&:hover': {
                    borderColor: '#bbb',
                    bgcolor: '#f5f5f5'
                  }
                }}
              >
                Schließen
              </Button>
              <Button
                type="submit"
                form="price-weight-form"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<Save />}
                sx={{
                  bgcolor: '#2e7d32',
                  color: 'white',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                  order: { xs: 1, sm: 2 },
                  '&:hover': {
                    bgcolor: '#1b5e20',
                    boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Preis und Gewicht aktualisieren
              </Button>
            </DialogActions>
          </Dialog>
        )
        :
        <></>
    );
  }
}

export default SetCustomPriceWeightPopup;
